import {
	usePurchaseOrdersGetById,
	usePurchaseOrdersGetMaterialAvailability,
} from '@/shared/api/generated/purchase-orders/purchase-orders';

export function usePoCommandCenter(identifier: string | undefined, poId: string | undefined) {
	return usePurchaseOrdersGetById(
		{ identifier: identifier!, id: poId! },
		{ query: { enabled: !!identifier && !!poId, staleTime: 5 * 60 * 1000, refetchOnWindowFocus: false, retry: 1 } }
	);
}

/**
 * The free stock in IFS of every part of a purchase order, and whether it is enough to issue the part (`canIssue`).
 * Issuing a part invalidates this query (see the issue-delivery feature).
 */
export function useMaterialAvailability(identifier: string | undefined, poId: string | undefined) {
	return usePurchaseOrdersGetMaterialAvailability(
		{ identifier: identifier!, id: poId! },
		// Stock moves in IFS while the page is open; re-read it each time the MTO tab mounts
		{ query: { enabled: !!identifier && !!poId, staleTime: 0 } }
	);
}
